// extracted by mini-css-extract-plugin
var _1 = "form-item__ucxo_";
var _2 = "form-modal__cpM7g";
var _3 = "form-modal-item__LaeJJ";
var _4 = "form-takeover__IjzK8";
var _5 = "form-takeover-item__ziOON";
export { _1 as "formItem", _2 as "formModal", _3 as "formModalItem", _4 as "formTakeover", _5 as "formTakeoverItem" }
